/**
 * @generated SignedSource<<75eac6010485f1d8049eaa1a98b1d0c2>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* eslint-disable */

'use strict';

var node = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "ContributionsCountBadge_contributions",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "totalCount",
      "storageKey": null
    }
  ],
  "type": "ContributionConnection",
  "abstractKey": null
};

node.hash = "038597a0b6a4539456b029a405f32757";

module.exports = node;
